// extracted by mini-css-extract-plugin
export default {"root":"aurfgOF4UuLqm8jL9U5u"};